export const MS_PER_CHAR = 3; // ms
//# sourceMappingURL=typewriter.constants.js.map